module.exports = __webpack_public_path__ + "img/member04.05f5e2e5.png";